export const data = [
  {
    destination: 'Bad Gastein',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '49',
    snowfall_days: '3',
    avg_snow_depth: '117',
    biggest_snowfall: '40',
  },
  {
    destination: 'Bad Gastein',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '44',
    snowfall_days: '4',
    avg_snow_depth: '181',
    biggest_snowfall: '30',
  },
  {
    destination: 'Bad Gastein',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '36',
    snowfall_days: '3',
    avg_snow_depth: '229',
    biggest_snowfall: '30',
  },
  {
    destination: 'Bad Gastein',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '31',
    snowfall_days: '3',
    avg_snow_depth: '234',
    biggest_snowfall: '30',
  },
  {
    destination: 'Bad Gastein',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '22',
    snowfall_days: '2',
    avg_snow_depth: '202',
    biggest_snowfall: '30',
  },
  /*
  {
    destination: 'Saalbach',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '111',
    snowfall_days: '8',
    avg_snow_depth: '64',
    biggest_snowfall: '70',
  },
  {
    destination: 'Saalbach',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '171',
    snowfall_days: '11',
    avg_snow_depth: '102',
    biggest_snowfall: '80',
  },
  {
    destination: 'Saalbach',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '98',
    snowfall_days: '7',
    avg_snow_depth: '131',
    biggest_snowfall: '80',
  },
  {
    destination: 'Saalbach',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '94',
    snowfall_days: '8',
    avg_snow_depth: '121',
    biggest_snowfall: '45',
  },
  {
    destination: 'Saalbach',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '18',
    snowfall_days: '2',
    avg_snow_depth: '100',
    biggest_snowfall: '35',
  },*/
  {
    destination: 'Obergurgl',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '103',
    snowfall_days: '8',
    avg_snow_depth: '139',
    biggest_snowfall: '100',
  },
  {
    destination: 'Obergurgl',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '109',
    snowfall_days: '9',
    avg_snow_depth: '178',
    biggest_snowfall: '100',
  },
  {
    destination: 'Obergurgl',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '73',
    snowfall_days: '8',
    avg_snow_depth: '185',
    biggest_snowfall: '35',
  },
  {
    destination: 'Obergurgl',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '68',
    snowfall_days: '7',
    avg_snow_depth: '167',
    biggest_snowfall: '46',
  },
  {
    destination: 'Obergurgl',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '54',
    snowfall_days: '4',
    avg_snow_depth: '137',
    biggest_snowfall: '60',
  },
  {
    destination: 'Sölden',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '105',
    snowfall_days: '7',
    avg_snow_depth: '190',
    biggest_snowfall: '86',
  },
  {
    destination: 'Sölden',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '120',
    snowfall_days: '10',
    avg_snow_depth: '246',
    biggest_snowfall: '80',
  },
  {
    destination: 'Sölden',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '93',
    snowfall_days: '8',
    avg_snow_depth: '290',
    biggest_snowfall: '50',
  },
  {
    destination: 'Sölden',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '82',
    snowfall_days: '8',
    avg_snow_depth: '304',
    biggest_snowfall: '60',
  },
  {
    destination: 'Sölden',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '87',
    snowfall_days: '7',
    avg_snow_depth: '322',
    biggest_snowfall: '100',
  },
  {
    destination: 'St Anton',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '81',
    snowfall_days: '6',
    avg_snow_depth: '117',
    biggest_snowfall: '80',
  },
  {
    destination: 'St Anton',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '119',
    snowfall_days: '9',
    avg_snow_depth: '205',
    biggest_snowfall: '60',
  },
  {
    destination: 'St Anton',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '74',
    snowfall_days: '6',
    avg_snow_depth: '255',
    biggest_snowfall: '40',
  },
  {
    destination: 'St Anton',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '79',
    snowfall_days: '7',
    avg_snow_depth: '278',
    biggest_snowfall: '50',
  },
  {
    destination: 'St Anton',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '41',
    snowfall_days: '4',
    avg_snow_depth: '268',
    biggest_snowfall: '30',
  },
  /*
  {
    destination: 'Ischgl',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '62',
    snowfall_days: '5',
    avg_snow_depth: '73',
    biggest_snowfall: '50',
  },
  {
    destination: 'Ischgl',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '64',
    snowfall_days: '6',
    avg_snow_depth: '102',
    biggest_snowfall: '50',
  },
  {
    destination: 'Ischgl',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '52',
    snowfall_days: '5',
    avg_snow_depth: '117',
    biggest_snowfall: '30',
  },
  {
    destination: 'Ischgl',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '42',
    snowfall_days: '5',
    avg_snow_depth: '124',
    biggest_snowfall: '30',
  },
  {
    destination: 'Ischgl',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '26',
    snowfall_days: '4',
    avg_snow_depth: '111',
    biggest_snowfall: '30',
  },
  {
    destination: 'Schladming',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '42',
    snowfall_days: '3',
    avg_snow_depth: '75',
    biggest_snowfall: '30',
  },
  {
    destination: 'Schladming',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '57',
    snowfall_days: '5',
    avg_snow_depth: '109',
    biggest_snowfall: '50',
  },
  {
    destination: 'Schladming',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '40',
    snowfall_days: '3',
    avg_snow_depth: '142',
    biggest_snowfall: '40',
  },
  {
    destination: 'Schladming',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '27',
    snowfall_days: '3',
    avg_snow_depth: '145',
    biggest_snowfall: '25',
  },
  {
    destination: 'Schladming',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '21',
    snowfall_days: '2',
    avg_snow_depth: '128',
    biggest_snowfall: '40',
  },*/
  {
    destination: 'Zell am See',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '80',
    snowfall_days: '6',
    avg_snow_depth: '145',
    biggest_snowfall: '60',
  },
  {
    destination: 'Zell am See',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '81',
    snowfall_days: '6',
    avg_snow_depth: '183',
    biggest_snowfall: '70',
  },
  {
    destination: 'Zell am See',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '62',
    snowfall_days: '5',
    avg_snow_depth: '235',
    biggest_snowfall: '59',
  },
  {
    destination: 'Zell am See',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '36',
    snowfall_days: '5',
    avg_snow_depth: '259',
    biggest_snowfall: '30',
  },
  {
    destination: 'Zell am See',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '48',
    snowfall_days: '5',
    avg_snow_depth: '266',
    biggest_snowfall: '35',
  },
  /*
  {
    destination: 'Lech-Zürs',
    country: 'AUT',
    month: 'December',
    avg_snowfall: '113',
    snowfall_days: '7',
    avg_snow_depth: '92',
    biggest_snowfall: '50',
  },
  {
    destination: 'Lech-Zürs',
    country: 'AUT',
    month: 'Januari',
    avg_snowfall: '128',
    snowfall_days: '8',
    avg_snow_depth: '160',
    biggest_snowfall: '100',
  },
  {
    destination: 'Lech-Zürs',
    country: 'AUT',
    month: 'Februari',
    avg_snowfall: '91',
    snowfall_days: '7',
    avg_snow_depth: '203',
    biggest_snowfall: '50',
  },
  {
    destination: 'Lech-Zürs',
    country: 'AUT',
    month: 'Mars',
    avg_snowfall: '88',
    snowfall_days: '7',
    avg_snow_depth: '225',
    biggest_snowfall: '50',
  },
  {
    destination: 'Lech-Zürs',
    country: 'AUT',
    month: 'April',
    avg_snowfall: '50',
    snowfall_days: '4',
    avg_snow_depth: '200',
    biggest_snowfall: '40',
  },*/
  {
    destination: 'Cervinia',
    country: 'ITA',
    month: 'December',
    avg_snowfall: '85',
    snowfall_days: '4',
    avg_snow_depth: '170',
    biggest_snowfall: '70',
  },
  {
    destination: 'Cervinia',
    country: 'ITA',
    month: 'Januari',
    avg_snowfall: '95',
    snowfall_days: '5',
    avg_snow_depth: '187',
    biggest_snowfall: '60',
  },
  {
    destination: 'Cervinia',
    country: 'ITA',
    month: 'Februari',
    avg_snowfall: '79',
    snowfall_days: '4',
    avg_snow_depth: '231',
    biggest_snowfall: '50',
  },
  {
    destination: 'Cervinia',
    country: 'ITA',
    month: 'Mars',
    avg_snowfall: '108',
    snowfall_days: '6',
    avg_snow_depth: '234',
    biggest_snowfall: '70',
  },
  {
    destination: 'Cervinia',
    country: 'ITA',
    month: 'April',
    avg_snowfall: '63',
    snowfall_days: '4',
    avg_snow_depth: '253',
    biggest_snowfall: '80',
  },
  /*
  {
    destination: 'Champoluc',
    country: 'ITA',
    month: 'December',
    avg_snowfall: '42',
    snowfall_days: '3',
    avg_snow_depth: '83',
    biggest_snowfall: '40',
  },
  {
    destination: 'Champoluc',
    country: 'ITA',
    month: 'Januari',
    avg_snowfall: '52',
    snowfall_days: '4',
    avg_snow_depth: '115',
    biggest_snowfall: '50',
  },
  {
    destination: 'Champoluc',
    country: 'ITA',
    month: 'Februari',
    avg_snowfall: '54',
    snowfall_days: '4',
    avg_snow_depth: '131',
    biggest_snowfall: '60',
  },
  {
    destination: 'Champoluc',
    country: 'ITA',
    month: 'Mars',
    avg_snowfall: '70',
    snowfall_days: '4',
    avg_snow_depth: '151',
    biggest_snowfall: '70',
  },
  {
    destination: 'Champoluc',
    country: 'ITA',
    month: 'April',
    avg_snowfall: '17',
    snowfall_days: '1',
    avg_snow_depth: '131',
    biggest_snowfall: '100',
  },
  {
    destination: 'Val Gardena',
    country: 'ITA',
    month: 'December',
    avg_snowfall: '44',
    snowfall_days: '4',
    avg_snow_depth: '63',
    biggest_snowfall: '40',
  },
  {
    destination: 'Val Gardena',
    country: 'ITA',
    month: 'Januari',
    avg_snowfall: '80',
    snowfall_days: '5',
    avg_snow_depth: '94',
    biggest_snowfall: '85',
  },
  {
    destination: 'Val Gardena',
    country: 'ITA',
    month: 'Februari',
    avg_snowfall: '84',
    snowfall_days: '6',
    avg_snow_depth: '123',
    biggest_snowfall: '105',
  },
  {
    destination: 'Val Gardena',
    country: 'ITA',
    month: 'Mars',
    avg_snowfall: '55',
    snowfall_days: '5',
    avg_snow_depth: '120',
    biggest_snowfall: '50',
  },
  {
    destination: 'Val Gardena',
    country: 'ITA',
    month: 'April',
    avg_snowfall: '1.5',
    snowfall_days: '1',
    avg_snow_depth: '116',
    biggest_snowfall: '80',
  },
  {
    destination: 'Canazei',
    country: 'ITA',
    month: 'December',
    avg_snowfall: '26',
    snowfall_days: '2',
    avg_snow_depth: '67',
    biggest_snowfall: '60',
  },
  {
    destination: 'Canazei',
    country: 'ITA',
    month: 'Januari',
    avg_snowfall: '52',
    snowfall_days: '4',
    avg_snow_depth: '106',
    biggest_snowfall: '80',
  },
  {
    destination: 'Canazei',
    country: 'ITA',
    month: 'Februari',
    avg_snowfall: '64',
    snowfall_days: '4',
    avg_snow_depth: '131',
    biggest_snowfall: '80',
  },
  {
    destination: 'Canazei',
    country: 'ITA',
    month: 'Mars',
    avg_snowfall: '58',
    snowfall_days: '4',
    avg_snow_depth: '150',
    biggest_snowfall: '60',
  },
  {
    destination: 'Canazei',
    country: 'ITA',
    month: 'April',
    avg_snowfall: '6',
    snowfall_days: '1',
    avg_snow_depth: '149',
    biggest_snowfall: '30',
  },
  {
    destination: "Sauze d'Oulx",
    country: 'ITA',
    month: 'December',
    avg_snowfall: '35',
    snowfall_days: '2',
    avg_snow_depth: '90',
    biggest_snowfall: '70',
  },
  {
    destination: "Sauze d'Oulx",
    country: 'ITA',
    month: 'Januari',
    avg_snowfall: '47',
    snowfall_days: '2',
    avg_snow_depth: '97',
    biggest_snowfall: '100',
  },
  {
    destination: "Sauze d'Oulx",
    country: 'ITA',
    month: 'Februari',
    avg_snowfall: '74',
    snowfall_days: '3',
    avg_snow_depth: '110',
    biggest_snowfall: '100',
  },
  {
    destination: "Sauze d'Oulx",
    country: 'ITA',
    month: 'Mars',
    avg_snowfall: '40',
    snowfall_days: '2',
    avg_snow_depth: '125',
    biggest_snowfall: '50',
  },
  {
    destination: "Sauze d'Oulx",
    country: 'ITA',
    month: 'April',
    avg_snowfall: '5',
    snowfall_days: '1',
    avg_snow_depth: '104',
    biggest_snowfall: '20',
  },*/
  {
    destination: 'Val Thorens',
    country: 'FRA',
    month: 'December',
    avg_snowfall: '136',
    snowfall_days: '10',
    avg_snow_depth: '140',
    biggest_snowfall: '74',
  },
  {
    destination: 'Val Thorens',
    country: 'FRA',
    month: 'Januari',
    avg_snowfall: '160',
    snowfall_days: '12',
    avg_snow_depth: '184',
    biggest_snowfall: '60',
  },
  {
    destination: 'Val Thorens',
    country: 'FRA',
    month: 'Februari',
    avg_snowfall: '107',
    snowfall_days: '10',
    avg_snow_depth: '228',
    biggest_snowfall: '40',
  },
  {
    destination: 'Val Thorens',
    country: 'FRA',
    month: 'Mars',
    avg_snowfall: '105',
    snowfall_days: '10',
    avg_snow_depth: '252',
    biggest_snowfall: '50',
  },
  {
    destination: 'Val Thorens',
    country: 'FRA',
    month: 'April',
    avg_snowfall: '65',
    snowfall_days: '7',
    avg_snow_depth: '245',
    biggest_snowfall: '30',
  },
];
